import { Typography } from '@mui/material';
import React from 'react';
import Loading from '../common/components/Loading';
import { useGetCreativeCreditsAndExperiences } from '../common/components/person/person';
import I18n from '../common/i18n/I18n';
import { C } from '../common/Layout';
import {
    removeEmptyCreativeCredits,
    removeEmptyExperiences
} from '../person/detailsPage/detailsPageUtilities/personBasicInformation';
import CreativeCreditsCard from '../person/detailsPage/personWorkSpecifications/CreativeCreditsCard';
import ProfessionalExperiencesCard from '../person/detailsPage/personWorkSpecifications/ProfessionalExperiencesCard';

const sectionScrollStyle = {
    maxHeight: { xs: '400px' },
    overflowY: 'auto',
    overflowX: 'hidden'
};

interface CreditsAndExperienceMarketplaceProps {
    item?: any;
    isOrganizationDetails?: boolean;
}

export default ({ item, isOrganizationDetails = false }: CreditsAndExperienceMarketplaceProps) => {
    const { creditsAndExperienceDetails, creditsAndExperienceDetailsLoading } = useGetCreativeCreditsAndExperiences(
        item?.id,
        isOrganizationDetails || !item?.id
    );

    const creativeCredits = creditsAndExperienceDetails?.person?.creativeCredits || item?.creativeCredits;
    const filteredCreativeCredits = creativeCredits && removeEmptyCreativeCredits(creativeCredits);

    const experiences = creditsAndExperienceDetails?.person?.experiences || item?.experiences;
    const filteredExperiences = experiences && removeEmptyExperiences(experiences);

    return (
        <>
            <C
                grow
                gap={2}
                sx={{
                    width: '100%',
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: 1,
                    p: 0.5
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        px: 2,
                        py: 1,
                        borderBottom: 1,
                        borderColor: 'divider'
                    }}
                >
                    <I18n token="person.creative.title" />
                </Typography>
                {creditsAndExperienceDetailsLoading ? (
                    <Loading />
                ) : (
                    <C sx={sectionScrollStyle}>
                        <CreativeCreditsCard
                            personName={item.name}
                            allowedEdit={false}
                            creativeCredits={filteredCreativeCredits}
                            fromMarketplace
                        />
                    </C>
                )}
            </C>
            <C
                grow
                gap={2}
                sx={{
                    width: '100%',
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: 1,
                    p: 0.5
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        px: 2,
                        py: 1,
                        borderBottom: 1,
                        borderColor: 'divider'
                    }}
                >
                    <I18n token="person.professional.title" />
                </Typography>
                {creditsAndExperienceDetailsLoading ? (
                    <Loading />
                ) : (
                    <C sx={sectionScrollStyle}>
                        <ProfessionalExperiencesCard
                            allowedEdit={false}
                            experiences={filteredExperiences}
                            fromMarketplace
                        />
                    </C>
                )}
            </C>
        </>
    );
};
